import { Divider, type DividerProps } from "@mui/material";

export default function DividerMui(props: DividerProps) {
  return <Divider {...props} />;
}
